import apiCall, { makeUrl } from "../../utils/apiCall";

export function* acceptMailchimpOauthResult({ code, redirectURI }) {
  const postZoomCall = yield apiCall();
  const result = yield postZoomCall.post(makeUrl("/mailchimp/accept-code"), {
    code,
    redirectURI,
  });
}
